import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  categories: [],
  subcategories: [],
  loading: false,
  error: null
};

export const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    getCategories: (state) => {
      state.loading = true;
    },
    addCategory: (state) => {
      state.loading = true;
    },
    updateCategory: (state) => {
      state.loading = true;
    },
    removeCategory: (state) => {
      state.loading = true;
    },
    getSubcategories: (state) => {
      state.loading = true;
    },
    addSubcategory: (state) => {
      state.loading = true;
    },
    updateSubcategory: (state) => {
      state.loading = true;
    },
    removeSubcategory: (state) => {
      state.loading = true;
    },

    successCategories: (state, action) => {
      state.loading = false;
      state.categories = action.payload;
      state.error = null;
    },
    successSubcategories: (state, action) => {
      state.loading = false;
      state.subcategories = action.payload;
      state.error = null;
    },
    failedCategory: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const {
  getCategories,
  addCategory,
  updateCategory,
  removeCategory,
  getSubcategories,
  addSubcategory,
  updateSubcategory,
  removeSubcategory,
  successCategories,
  successSubcategories,
  failedCategory
} = categorySlice.actions;

export default categorySlice.reducer;